import { getRootConfig } from '@core/utils/helpers';
import rootConfig from '../../tests/data/root.config';

export default function(key: string) {
  return getRootConfig(key) || rootConfig[key];
}
